<template>
  <div></div>
</template>

<script>
export default {
  name: 'ReturnConfirmation',

  props: {
    agendaId: {
      type: Number,
      required: true
    }
  },

  mounted () {
    this.$store.dispatch('setModalConfirm', {
      title: 'Confirmação de retorno de consulta',
      body: `Por padrão, esta consulta permite o agendamento de retorno
        em até 30 dias.
        <br><br>
        <strong>Deseja manter o retorno para essa consulta?</strong>`,
      confirmText: 'Sim',
      cancelText: 'Não',
      beforeClose: (v) => {
        if (!v) {
          this.fn_SHOW_PROGRESS()
          this.cancelReturn()
            .then(this.showCancelConfirmation)
            .catch(this.fn_HANDLE_ERROR)
            .finally(this.fn_HIDE_PROGRESS)
        }

        this.$store.dispatch('setModalConfirm')
      },
      size: 'md',
      active: true
    })
  },

  methods: {
    cancelReturn () {
      return new Promise((resolve, reject) => {
        const url = `/doctor/agenda/${this.agendaId}/return_medical_consultation`

        return this.$http.delete(url, this.$store.getters.getAuthHeader)
          .then(resolve)
          .catch(reject)
      })
    },

    showCancelConfirmation () {
      this.$store.dispatch('setModalAlert', {
        title: 'Sucesso',
        body: 'Retorno automático cancelado com sucesso.',
        size: 'md',
        active: true
      })
    }
  }
}
</script>
